import {
  Alert,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Icon,
  MenuItem,
  Paper,
  Stack,
  TextField
} from "@mui/material";
import { useEffect, useState } from "react";
import { TIPOS } from "../../shared/apresentacaoEvento";
export function filtrosPadrao() {
  const now = new Date();
  const inicio = new Date(now.getFullYear(), now.getMonth(), 1);
  const iso = (d) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
      d.getDate()
    ).padStart(2, "0")}`;
  return {
    modo: "PERIODO",
    dataInicial: iso(inicio),
    dataFinal: iso(now),
    competencia: iso(now).slice(0, 7),
    cpf: "",
    nome: "",
    matricula: "",
    tipos: "",
    incluirArquivados: false
  };
}
export function parametrosFiltro(filtro) {
  const { modo, ...rest } = filtro;
  if (modo === "COMPETENCIA") {
    delete rest.dataInicial;
    delete rest.dataFinal;
  } else delete rest.competencia;
  return { ...rest, cpf: (rest.cpf || "").replace(/\D/g, "") };
}
export default function FiltrosPessoas({
  value,
  onSubmit,
  periodo = false,
  busy = false
}) {
  const [f, setF] = useState(value);
  const [erro, setErro] = useState("");
  useEffect(() => setF(value), [value]);
  const field = (k) => ({
    value: f[k] || "",
    onChange: (e) => setF({ ...f, [k]: e.target.value }),
    size: "small",
    fullWidth: true
  });
  function aplicar(e) {
    e.preventDefault();
    setErro("");
    if (f.cpf && !/^\d{11}$/.test(f.cpf.replace(/\D/g, "")))
      return setErro("Informe um CPF com 11 dígitos.");
    if (
      periodo &&
      f.modo === "COMPETENCIA" &&
      !/^\d{4}(-(?:0[1-9]|1[0-2]))?$/.test(f.competencia || "")
    )
      return setErro(
        "Informe a competência como AAAA-MM ou AAAA para o 13º salário."
      );
    if (
      periodo &&
      f.modo !== "COMPETENCIA" &&
      (!f.dataInicial ||
        !f.dataFinal ||
        f.dataInicial > f.dataFinal ||
        (new Date(f.dataFinal) - new Date(f.dataInicial)) / 86400000 > 365)
    )
      return setErro(
        "Informe um período de recebimento válido de até 366 dias."
      );
    onSubmit({ ...f });
  }
  return (
    <Paper
      component="form"
      onSubmit={aplicar}
      variant="outlined"
      sx={{ p: 2, mb: 3, borderRadius: 2 }}
    >
      <Grid container spacing={2}>
        {periodo && (
          <>
            <Grid item xs={12} md={3}>
              <TextField {...field("modo")} select label="Consultar por">
                <MenuItem value="PERIODO">Período de recebimento</MenuItem>
                <MenuItem value="COMPETENCIA">Competência de apuração</MenuItem>
              </TextField>
            </Grid>
            {f.modo === "COMPETENCIA" ? (
              <Grid item xs={12} md={6}>
                <TextField
                  {...field("competencia")}
                  label="Competência"
                  placeholder="2026-10 ou 2026 (13º)"
                />
              </Grid>
            ) : (
              <>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    {...field("dataInicial")}
                    type="date"
                    label="Recebido de"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    {...field("dataFinal")}
                    type="date"
                    label="Recebido até"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              </>
            )}
          </>
        )}
        <Grid item xs={12} md={periodo ? 3 : 4}>
          <TextField {...field("tipos")} select label="Tipo de evento">
            <MenuItem value="">Todos os tipos</MenuItem>
            {Object.entries(TIPOS).map(([v, l]) => (
              <MenuItem key={v} value={v}>
                S-{v} · {l}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            {...field("nome")}
            label="Nome da pessoa"
            inputProps={{ maxLength: 100 }}
          />
        </Grid>
        <Grid item xs={6} md={periodo ? 3 : 2}>
          <TextField
            {...field("cpf")}
            label="CPF"
            inputProps={{ maxLength: 14 }}
          />
        </Grid>
        <Grid item xs={6} md={periodo ? 3 : 2}>
          <TextField
            {...field("matricula")}
            label="Matrícula"
            inputProps={{ maxLength: 50 }}
          />
        </Grid>
        {!periodo && (
          <Grid item xs={12}>
            <TextField
              {...field("expressao")}
              label="Conteúdo do evento"
              placeholder="Rubrica, recibo ou outro dado enviado"
              inputProps={{ maxLength: 150 }}
            />
          </Grid>
        )}
      </Grid>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ sm: "center" }}
        spacing={1}
        sx={{ mt: 2 }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={Boolean(f.incluirArquivados)}
              onChange={(e) =>
                setF({ ...f, incluirArquivados: e.target.checked })
              }
            />
          }
          label="Incluir arquivados"
        />
        <Stack direction="row" spacing={1}>
          <Button
            type="button"
            onClick={() => {
              const limpo = periodo
                ? filtrosPadrao()
                : {
                    nome: "",
                    cpf: "",
                    matricula: "",
                    tipos: "",
                    expressao: "",
                    incluirArquivados: false
                  };
              setErro("");
              setF(limpo);
              onSubmit(limpo);
            }}
          >
            Limpar filtros
          </Button>
          <Button
            type="submit"
            variant="contained"
            startIcon={<Icon>search</Icon>}
            disabled={busy}
          >
            Consultar
          </Button>
        </Stack>
      </Stack>
      {erro && (
        <Alert severity="warning" sx={{ mt: 2 }}>
          {erro}
        </Alert>
      )}
    </Paper>
  );
}
